import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";

export default function PastorDashboard() {
  return (
    <MDBox py={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="dark"
              icon="groups"
              title="Congregation"
              count={850}
              percentage={{
                color: "success",
                amount: "+12",
                label: "new members",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              icon="event"
              title="Today's Attendance"
              count="420"
              percentage={{
                color: "success",
                amount: "+8%",
                label: "than last week",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="success"
              icon="volunteer_activism"
              title="Today's Offering"
              count="₦120,500"
              percentage={{
                color: "success",
                amount: "+15%",
                label: "than last week",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="primary"
              icon="event_available"
              title="Upcoming Events"
              count="3"
              percentage={{
                color: "info",
                amount: "",
                label: "this week",
              }}
            />
          </MDBox>
        </Grid>

        {/* Pastor-specific sections */}
        <Grid item xs={12}>
          <MDBox mb={3}>
            <ReportsLineChart
              color="success"
              title="Weekly Attendance Trend"
              description="Last 4 weeks comparison"
              chart={attendanceChartData}
            />
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}
